// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-wrapper {
  position: relative;
  width: 20px;
  height: 300px;
  background-color: #f0f0f0;
  border-radius: 50px;
  overflow: visible;
  display: flex;
  justify-content: center;
  margin: 0 0 10px 0;
}

.progress {
  position: absolute;
  top: 0;
  width: 100%;
  height: 0%;
  background: #3DA06A;
  transition: height 0.5s ease;
  border-radius: 50px;
}

.login-indicator {
  position: absolute;
  width: 24px;
  height: 24px;
  background: #fff;
  border-radius: 50%;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  border: 2px solid #3182ce;
}

.login-time-label {
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #333;
  white-space: nowrap;
  z-index: 100;
  font-weight: 500;
}

@media (min-width: 1440px) {
  .progress-wrapper {
    width: 30px; 
    height: 420px; 
  }

  .progress {
    border-radius: 60px;
  }

  .login-indicator {
    width: 32px;
    height: 32px;
    border-width: 3px;
  }

  .login-time-label {
    font-size: 1.45rem;
    left: 40px;
  }

  .time-label {
    font-size: 1.45rem;
  }

    .time-label.start-time {
    left: -200px;
    font-size: 1.45rem;
  }

  .time-label.end-time {
    right: -250px;
    font-size: 1.45rem;
  }

}

@media (min-width: 1920px) {
  .progress-wrapper {
    width: 40px;
    height: 500px;
  }

   .time-label.start-time {
    left: -200px;
    font-size: 1.45rem;
  }

  .time-label.end-time {
    right: -250px;
    font-size: 1.45rem;
  }

  .progress {
    border-radius: 70px;
  }

  .login-indicator {
    width: 36px;
    height: 36px;
    border-width: 3px;
  }

  .login-time-label {
    font-size: 1.45rem;
    left: 50px;
  }

  .time-label {
    font-size: 1.45rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/Shared/Pages/verticalprogress/verticalprogress.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,MAAM;EACN,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;IAEE;IACA,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;AAEF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;;GAEC;IACC,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".progress-wrapper {\n  position: relative;\n  width: 20px;\n  height: 300px;\n  background-color: #f0f0f0;\n  border-radius: 50px;\n  overflow: visible;\n  display: flex;\n  justify-content: center;\n  margin: 0 0 10px 0;\n}\n\n.progress {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 0%;\n  background: #3DA06A;\n  transition: height 0.5s ease;\n  border-radius: 50px;\n}\n\n.login-indicator {\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  background: #fff;\n  border-radius: 50%;\n  left: 50%;\n  transform: translateX(-50%);\n  top: 0;\n  border: 2px solid #3182ce;\n}\n\n.login-time-label {\n  position: absolute;\n  left: 30px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 12px;\n  color: #333;\n  white-space: nowrap;\n  z-index: 100;\n  font-weight: 500;\n}\n\n@media (min-width: 1440px) {\n  .progress-wrapper {\n    width: 30px; \n    height: 420px; \n  }\n\n  .progress {\n    border-radius: 60px;\n  }\n\n  .login-indicator {\n    width: 32px;\n    height: 32px;\n    border-width: 3px;\n  }\n\n  .login-time-label {\n    font-size: 1.45rem;\n    left: 40px;\n  }\n\n  .time-label {\n    font-size: 1.45rem;\n  }\n\n    .time-label.start-time {\n    left: -200px;\n    font-size: 1.45rem;\n  }\n\n  .time-label.end-time {\n    right: -250px;\n    font-size: 1.45rem;\n  }\n\n}\n\n@media (min-width: 1920px) {\n  .progress-wrapper {\n    width: 40px;\n    height: 500px;\n  }\n\n   .time-label.start-time {\n    left: -200px;\n    font-size: 1.45rem;\n  }\n\n  .time-label.end-time {\n    right: -250px;\n    font-size: 1.45rem;\n  }\n\n  .progress {\n    border-radius: 70px;\n  }\n\n  .login-indicator {\n    width: 36px;\n    height: 36px;\n    border-width: 3px;\n  }\n\n  .login-time-label {\n    font-size: 1.45rem;\n    left: 50px;\n  }\n\n  .time-label {\n    font-size: 1.45rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
